import React from 'react';

interface DataCardProps {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  extra?: React.ReactNode;
  children: React.ReactNode;
  padding?: string | number;
  bodyStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  className?: string;
}

const DataCard: React.FC<DataCardProps> = ({
  title,
  icon,
  extra,
  children,
  padding,
  bodyStyle,
  style,
  className = '',
}) => {
  const headerNode = title ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 'clamp(10px, 1vw, 14px) clamp(16px, 1.5vw, 20px)',
        borderBottom: '1px solid var(--jds-border-color)',
        minHeight: 48,
        flexWrap: 'wrap',
        gap: 8,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 'var(--font-md)',
          fontWeight: 600,
          color: 'var(--jds-text-primary)',
        }}
      >
        {icon && <span style={{ color: '#1677ff' }}>{icon}</span>}
        {title}
      </div>
      {extra && <div className="jds-card-extra">{extra}</div>}
    </div>
  ) : null;

  return (
    <div
      className={`jds-card ${className}`}
      style={{
        overflow: 'hidden',
        ...style,
      }}
    >
      {headerNode}
      <div
        style={{
          padding: padding !== undefined ? padding : 'clamp(14px, 1.5vw, 20px)',
          ...bodyStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default DataCard;
